const CoursesPop = ({ attachedCourse }) => {
    return (
        <div className="modal_body">
            <div className="attached_courses">
                <h2>attached courses <span className="mt_2">{attachedCourse.name}</span></h2>
                {
                    attachedCourse?.course_count?.map(course => (
                        <p>{course.name}<span className="mt_2">{course.instructor.map((ins, index) => {
                            if (course.instructor.length === index + 1) {
                                return ins.name
                            } else {
                                return ins.name + ", "
                            }

                        })}</span></p>
                    ))
                }
            </div>
        </div>
    )
};

export default CoursesPop;